import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { checklist } from '../data/offer';
export function ChecklistSection() {
  return <section className="bg-stage starfield py-16" aria-labelledby="includes-title" data-id="element-46" data-mp="2lyc233hxa9dj">
      <div className="mx-auto max-w-5xl px-4" data-id="element-47" data-mp="2m0etnryq4akd">
        <h2 id="includes-title" className="text-center text-3xl font-extrabold text-white" data-id="element-48" data-mp="2qw3vk1y7u3ju">Todos los tomos incluyen</h2>
        <div className="mt-9 grid gap-x-10 gap-y-4 md:grid-cols-2" data-id="element-49" data-mp="2c6pfyc41qpw0">
          {checklist.map(([title, detail], index) => <motion.div key={title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.02,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl p-2" data-id="element-50" data-mp="2h0tt5d3wnu5j" data-mpi={index}>
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-51" data-mp="1y7g2hk7869vq" />
              <p data-id="element-52" data-mp="1is51kvqmr4pz">
                <b className="block text-sm text-white" data-id="element-53" data-mp="1irlk1g4w6ich">{title}</b>
                <span className="text-sm text-mutedDark" data-id="element-54" data-mp="1dttsin85sy8t">{detail}</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}